// src/components/MaintenanceBanner/MaintenanceBanner.tsx
import React, { useEffect, useState } from 'react'
import styled from 'styled-components';

interface MaintenanceBannerProps {
  message?: string;
  isVisible: boolean;
}

const MessageContainer = styled.div`
  flex: 1;
  text-align: center;
`;

const CloseButton = styled.button`
  background: transparent;
  border: none;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  color: #333;
  margin-right: 25px;
  padding: 5px 10px;
  border-radius: 50%;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
`;

const BannerContainer = styled.div<{ isVisible: boolean }>`
  display: ${props => (props.isVisible ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  background-color: #ffe57f;
  color: #333;
  width: 100%;
  padding: 10px 20px;
  text-align: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
`;

const MaintenanceBanner: React.FC<MaintenanceBannerProps> = ({
   message = 'Application is currently under maintenance.',
   isVisible
 }) => {
  const [isDismissed, setIsDismissed] = useState(false);

  // Reset dismissed state when isVisible changes
  useEffect(() => {
    if (isVisible) {
      setIsDismissed(false);
    }
  }, [isVisible]);

  const handleClose = () => {
    setIsDismissed(true);
  };

  if (!isVisible || isDismissed) return null;

  return (
    <BannerContainer isVisible={isVisible && !isDismissed}>
      <MessageContainer>
        <p>{message}</p>
      </MessageContainer>
      <CloseButton onClick={handleClose} aria-label="Close maintenance banner">
        ✕
      </CloseButton>
    </BannerContainer>
  );
};

export default MaintenanceBanner;
